import React, { useState } from 'react';
import '../../../../assets/css/Ngo/controlpanelCSS/fundDistribution.css';
import NgoLayout from '../../../../layouts/Ngo/NgoLayout'
import { Search, Eye, Download, Filter, X } from 'lucide-react';
// Sample data
const sampleDonations = [
  {
    id: 1,
    studentName: 'Ali Khan',
    requestedAmount: 50000,
    donatedAmount: 30000,
    remaining: 20000,
    donorName: 'Ayaan Ahmad',
    donationDate: '21-Jan-2026',
    status: 'completed',
    donorLevel: 'Silver',
    studentAge: 16,
    studentClass: '10th Grade',
    purpose: 'School Fees & Books',
    donorEmail: 'ayaanahmad@example.com',
    donorPhone: '+92-300-1234567'
  },
  {
    id: 2,
    studentName: 'Sara Ahmed',
    requestedAmount: 20000,
    donatedAmount: 20000,
    remaining: 0,
    donorName: 'Sania Khan',
    donationDate: '20-Jan-2026',
    status: 'Completed',
    donorLevel: 'Gold',
    studentAge: 15,
    studentClass: '9th Grade',
    purpose: 'Uniform & Supplies',
    donorEmail: 'saniakhan@example.com',
    donorPhone: '+92-301-9876543'
  },
  {
    id: 3,
    studentName: 'Ahmed Raza',
    requestedAmount: 35000,
    donatedAmount: 15000,
    remaining: 20000,
    donorName: 'Faizan Malik',
    donationDate: '19-Jan-2026',
    status: 'completed',
    donorLevel: 'Bronze',
    studentAge: 17,
    studentClass: '11th Grade',
    purpose: 'Tuition Fees',
    donorEmail: 'faizanmalik@example.com',
    donorPhone: '+92-302-5551234'
  },
  {
    id: 4,
    studentName: 'Fatima Noor',
    requestedAmount: 45000,
    donatedAmount: 45000,
    remaining: 0,
    donorName: 'Ayaan Ahmad',
    donationDate: '18-Jan-2026',
     status: 'Pending',
    donorLevel: 'Platinum',
    studentAge: 14,
    studentClass: '8th Grade',
    purpose: 'Annual Education Fund',
    donorEmail: 'ayaanahmad@example.com',
    donorPhone: '+92-303-7778888'
  },
  // {
  //   id: 5,
  //   studentName: 'Hassan Ali',
  //   requestedAmount: 25000,
  //   donatedAmount: 0,
  //   remaining: 25000,
  //   donorName: '-',
  //   donationDate: '-',
  //   status: 'Pending',
  //   donorLevel: '-',
  //   studentAge: 13,
  //   studentClass: '7th Grade',
  //   purpose: 'Books & Stationery',
  //   donorEmail: '-',
  //   donorPhone: '-'
  // },
  // {
  //   id: 6,
  //   studentName: 'Zainab Malik',
  //   requestedAmount: 40000,
  //   donatedAmount: 25000,
  //   remaining: 15000,
  //   donorName: 'Usman',
  //   donationDate: '17-Jan-2026',
  //   status: 'Partial',
  //   donorLevel: 'Gold',
  //   studentAge: 16,
  //   studentClass: '10th Grade',
  //   purpose: 'Exam & Lab Fees',
  //   donorEmail: 'usman@example.com',
  //   donorPhone: '+92-304-2223333'
  // }
];

const DonationTracker = () => {
  const [donations, setDonations] = useState(sampleDonations);
  const [filteredDonations, setFilteredDonations] = useState(sampleDonations);
  const [selectedStudent, setSelectedStudent] = useState('');
  const [selectedDonor, setSelectedDonor] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedDonation, setSelectedDonation] = useState(null);
  const itemsPerPage = 5;

  // Get unique values for dropdowns
  const students = [...new Set(donations.map(d => d.studentName))];
  const donors = [...new Set(donations.map(d => d.donorName).filter(d => d !== '-'))];
  const statuses = [...new Set(donations.map(d => d.status))];

  const handleSearch = () => {
    let filtered = donations;

    if (selectedStudent) {
      filtered = filtered.filter(d => d.studentName === selectedStudent);
    }
    if (selectedDonor) {
      filtered = filtered.filter(d => d.donorName === selectedDonor);
    }
    if (selectedStatus) {
      filtered = filtered.filter(d => d.status === selectedStatus);
    }

    setFilteredDonations(filtered);
    setCurrentPage(1);
  };

  const handleReset = () => {
    setSelectedStudent('');
    setSelectedDonor('');
    setSelectedStatus('');
    setDateFrom('');
    setDateTo('');
    setFilteredDonations(donations);
    setCurrentPage(1);
  };

  const handleViewDetails = (donation) => {
    setSelectedDonation(donation);
  };

  const handleCloseModal = () => {
    setSelectedDonation(null);
  };

  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredDonations.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredDonations.length / itemsPerPage);

  const getStatusColor = (status) => {
    switch(status) {
      case 'Completed': return 'dt-status-completed';
      case 'Partial': return 'dt-status-partial';
      case 'Pending': return 'dt-status-pending';
      default: return 'dt-status-default';
    }
  };

  const getDonorLevelColor = (level) => {
    switch(level) {
      case 'Platinum': return 'dt-level-platinum';
      case 'Gold': return 'dt-level-gold';
      case 'Silver': return 'dt-level-silver';
      case 'Bronze': return 'dt-level-bronze';
      default: return 'dt-level-default';
    }
  };

  return (
    <NgoLayout>
    <div className="dt-container">
      {/* Header */}
      <div className="dt-header">
        <h1 className="dt-title">Donation Tracking System</h1>
        <p className="dt-subtitle">Manage and monitor student donations efficiently</p>
      </div>

      {/* Filters Section */}
      <div className="dt-filters-card">
        <div className="dt-filters-header">
          <Filter size={20} />
          <span>Filter Donations</span>
        </div>
        
        <div className="dt-filters-grid">
          <div className="dt-form-group">
            <label className="dt-label">Student Name</label>
            <select 
              className="dt-select"
              value={selectedStudent}
              onChange={(e) => setSelectedStudent(e.target.value)}
            >
              <option value="">All Students</option>
              {students.map(student => (
                <option key={student} value={student}>{student}</option>
              ))}
            </select>
          </div>

          <div className="dt-form-group">
            <label className="dt-label">Donor Name</label>
            <select 
              className="dt-select"
              value={selectedDonor}
              onChange={(e) => setSelectedDonor(e.target.value)}
            >
              <option value="">All Donors</option>
              {donors.map(donor => (
                <option key={donor} value={donor}>{donor}</option>
              ))}
            </select>
          </div>

          <div className="dt-form-group">
            <label className="dt-label">Status</label>
            <select 
              className="dt-select"
              value={selectedStatus}
              onChange={(e) => setSelectedStatus(e.target.value)}
            >
              <option value="">All Status</option>
              {statuses.map(status => (
                <option key={status} value={status}>{status}</option>
              ))}
            </select>
          </div>

          <div className="dt-form-group">
            <label className="dt-label">Date From</label>
            <input 
              type="date" 
              className="dt-input"
              value={dateFrom}
              onChange={(e) => setDateFrom(e.target.value)}
            />
          </div>

          <div className="dt-form-group">
            <label className="dt-label">Date To</label>
            <input 
              type="date" 
              className="dt-input"
              value={dateTo}
              onChange={(e) => setDateTo(e.target.value)}
            />
          </div>

          <div className="dt-form-group dt-button-group">
            <button className="dt-btn dt-btn-primary" onClick={handleSearch}>
              <Search size={18} />
              Search
            </button>
            <button className="dt-btn dt-btn-secondary" onClick={handleReset}>
              Reset
            </button>
          </div>
        </div>
      </div>

      {/* Summary Cards */}
      <div className="dt-summary-grid">
        <div className="dt-summary-card dt-card-primary">
          <div className="dt-summary-label">Total Requested</div>
          <div className="dt-summary-value">
            Rs. {filteredDonations.reduce((sum, d) => sum + d.requestedAmount, 0).toLocaleString()}
          </div>
        </div>
        <div className="dt-summary-card dt-card-success">
          <div className="dt-summary-label">Total Donated</div>
          <div className="dt-summary-value">
            Rs. {filteredDonations.reduce((sum, d) => sum + d.donatedAmount, 0).toLocaleString()}
          </div>
        </div>
        <div className="dt-summary-card dt-card-warning">
          <div className="dt-summary-label">Total Remaining</div>
          <div className="dt-summary-value">
            Rs. {filteredDonations.reduce((sum, d) => sum + d.remaining, 0).toLocaleString()}
          </div>
        </div>
        <div className="dt-summary-card dt-card-info">
          <div className="dt-summary-label">Total Records</div>
          <div className="dt-summary-value">{filteredDonations.length}</div>
        </div>
      </div>

      {/* Table */}
      <div className="dt-table-card">
        <div className="dt-table-header">
          <h2 className="dt-table-title">Donation Records</h2>
          <button className="dt-btn dt-btn-outline">
            <Download size={18} />
            Export
          </button>
        </div>

        <div className="dt-table-responsive">
          <table className="dt-table">
            <thead>
              <tr>
                <th>Student Name</th>
                <th>Requested</th>
                <th>Donated</th>
                <th>Remaining</th>
                <th>Donor Name</th>
                <th>Date</th>
                <th>Status</th>
                <th>Donor Level</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {currentItems.map(donation => (
                <tr key={donation.id}>
                  <td className="dt-student-name">{donation.studentName}</td>
                  <td className="dt-amount">Rs. {donation.requestedAmount.toLocaleString()}</td>
                  <td className="dt-amount dt-amount-donated">Rs. {donation.donatedAmount.toLocaleString()}</td>
                  <td className="dt-amount dt-amount-remaining">Rs. {donation.remaining.toLocaleString()}</td>
                  <td>{donation.donorName}</td>
                  <td>{donation.donationDate}</td>
                  <td>
                    <span className={`dt-status ${getStatusColor(donation.status)}`}>
                      {donation.status}
                    </span>
                  </td>
                  <td>
                    <span className={`dt-badge ${getDonorLevelColor(donation.donorLevel)}`}>
                      {donation.donorLevel}
                    </span>
                  </td>
                  <td>
                    <button 
                      className="dt-btn-icon"
                      onClick={() => handleViewDetails(donation)}
                      title="View Details"
                    >
                      <Eye size={18} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="dt-pagination">
          <div className="dt-pagination-info">
            Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredDonations.length)} of {filteredDonations.length} entries
          </div>
          <div className="dt-pagination-buttons">
            <button 
              className="dt-btn dt-btn-sm"
              onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
            >
              Previous
            </button>
            {[...Array(totalPages)].map((_, index) => (
              <button
                key={index}
                className={`dt-btn dt-btn-sm ${currentPage === index + 1 ? 'dt-btn-active' : ''}`}
                onClick={() => setCurrentPage(index + 1)}
              >
                {index + 1}
              </button>
            ))}
            <button 
              className="dt-btn dt-btn-sm"
              onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        </div>
      </div>

      {/* Modal */}
      {selectedDonation && (
        <div className="dt-modal-overlay" onClick={handleCloseModal}>
          <div className="dt-modal" onClick={(e) => e.stopPropagation()}>
            <div className="dt-modal-header">
              <h2>Donation Details</h2>
              <button className="dt-modal-close" onClick={handleCloseModal}>
                <X size={24} />
              </button>
            </div>
            <div className="dt-modal-body">
              <div className="dt-detail-section">
                <h3 className="dt-detail-heading">Student Information</h3>
                <div className="dt-detail-grid">
                  <div className="dt-detail-item">
                    <span className="dt-detail-label">Name:</span>
                    <span className="dt-detail-value">{selectedDonation.studentName}</span>
                  </div>
                  <div className="dt-detail-item">
                    <span className="dt-detail-label">Age:</span>
                    <span className="dt-detail-value">{selectedDonation.studentAge} years</span>
                  </div>
                  <div className="dt-detail-item">
                    <span className="dt-detail-label">Class:</span>
                    <span className="dt-detail-value">{selectedDonation.studentClass}</span>
                  </div>
                  <div className="dt-detail-item">
                    <span className="dt-detail-label">Purpose:</span>
                    <span className="dt-detail-value">{selectedDonation.purpose}</span>
                  </div>
                </div>
              </div>

              <div className="dt-detail-section">
                <h3 className="dt-detail-heading">Financial Details</h3>
                <div className="dt-detail-grid">
                  <div className="dt-detail-item">
                    <span className="dt-detail-label">Requested Amount:</span>
                    <span className="dt-detail-value dt-detail-primary">Rs. {selectedDonation.requestedAmount.toLocaleString()}</span>
                  </div>
                  <div className="dt-detail-item">
                    <span className="dt-detail-label">Donated Amount:</span>
                    <span className="dt-detail-value dt-detail-success">Rs. {selectedDonation.donatedAmount.toLocaleString()}</span>
                  </div>
                  <div className="dt-detail-item">
                    <span className="dt-detail-label">Remaining Amount:</span>
                    <span className="dt-detail-value dt-detail-warning">Rs. {selectedDonation.remaining.toLocaleString()}</span>
                  </div>
                  <div className="dt-detail-item">
                    <span className="dt-detail-label">Status:</span>
                    <span className={`dt-status ${getStatusColor(selectedDonation.status)}`}>
                      {selectedDonation.status}
                    </span>
                  </div>
                </div>
              </div>

              {selectedDonation.donorName !== '-' && (
                <div className="dt-detail-section">
                  <h3 className="dt-detail-heading">Donor Information</h3>
                  <div className="dt-detail-grid">
                    <div className="dt-detail-item">
                      <span className="dt-detail-label">Name:</span>
                      <span className="dt-detail-value">{selectedDonation.donorName}</span>
                    </div>
                    <div className="dt-detail-item">
                      <span className="dt-detail-label">Level:</span>
                      <span className={`dt-badge ${getDonorLevelColor(selectedDonation.donorLevel)}`}>
                        {selectedDonation.donorLevel}
                      </span>
                    </div>
                    <div className="dt-detail-item">
                      <span className="dt-detail-label">Email:</span>
                      <span className="dt-detail-value">{selectedDonation.donorEmail}</span>
                    </div>
                    <div className="dt-detail-item">
                      <span className="dt-detail-label">Phone:</span>
                      <span className="dt-detail-value">{selectedDonation.donorPhone}</span>
                    </div>
                    <div className="dt-detail-item">
                      <span className="dt-detail-label">Donation Date:</span>
                      <span className="dt-detail-value">{selectedDonation.donationDate}</span>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="dt-modal-footer">
              <button className="dt-btn dt-btn-secondary" onClick={handleCloseModal}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
    </NgoLayout>
  );
};

export default DonationTracker;